import { Button } from '@mui/material';
import { Result } from 'antd';
import notFoundBanner from 'assets/svgs/404.svg';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPath } from 'routes/router-paths';

const NotFoundResult = () => {
  const navigate = useNavigate();

  return (
    <Result
      icon={<img src={notFoundBanner} alt="404" width={350} height={350} />}
      title={<strong className="text-2xl">Không tìm thấy trang</strong>}
      subTitle="Trang bạn tìm kiếm không tồn tại. Vui lòng quay lại trang trước hoặc trở lại trang chủ."
      extra={
        <div className="flex justify-center gap-x-4">
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Quay lại trang trước
          </Button>
          <Button onClick={() => navigate(getPath('portalPage'))}>
            Về trang chủ
          </Button>
        </div>
      }
    />
  );
};

export default memo(NotFoundResult);
